import React from 'lib/react';
import {
  EVCircularProgress, EVGrid, makeStyles,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';
import Typography from 'commonComponents/typography';

const useStyles = makeStyles((theme) => ({
  circularProgress: ({ isFocused }) => ({
    color: isFocused ? theme.evPalette.salt[100] : theme.evPalette.ocean[600],
  }),
}));

function LoadingAddress({ isFocused = false }) {
  const { t } = useTranslation();
  const classes = useStyles({ isFocused });

  return (
    <EVGrid container alignItems="center" style={{ gap: '8px' }}>
      <Typography>
        {t('order__loading_address')}
      </Typography>
      <EVCircularProgress size={24} className={classes.circularProgress} />
    </EVGrid>
  );
}

LoadingAddress.propTypes = {
  isFocused: PropTypes.bool.isRequired,
};

export default LoadingAddress;
